import clsx from "clsx";
import { useFormContext } from "react-hook-form";
import Divider from "@mui/material/Divider";
import { FormControlLabel, Radio, RadioGroup } from "@mui/material";
import { useCallback } from "react";
import { Text } from "$components";
import CField from "$forms/CField";
import { useStyles } from "../../styles/DeliveryPicker.styles";
import BataillogDatePicker from "$components/BataillogDatePicker/BataillogDatePicker";
import { toLocalDateString } from "$utils/utils";

export default function DateDispo() {
  const classes = useStyles();
  const {
    control,
    watch,
    setValue,
    formState: { errors },
  } = useFormContext();

  // Watch the form value to ensure UI is in sync
  // Changed default from true to false to select "Au plus tard le" by default
  const dispositionDateIsExact = watch("dispositionDateIsExact", false);

  // Handle radio button change with useCallback to prevent infinite loops
  const handleDateTypeChange = useCallback(
    (event) => {
      const isExact = event.target.value === "true";
      setValue("dispositionDateIsExact", isExact, { shouldValidate: true });
    },
    [setValue]
  );

  return (
    <div className={`${classes.contentStep3} show`}>
      <div className={classes.contentStep3Title}>
        <Text className={classes.subtitle}>
          Date de mise à disposition souhaitée
        </Text>
      </div>
      <div
        className={clsx(classes.contentStep3Content)}
        style={{
          flex: 1,
          display: "flex",
        }}
      >
        <CField
          control={control}
          label="Date de mise à disposition"
          name="dispositionDate"
          error={errors.dispositionDate}
          required
          variant="outlined"
          style={{
            paddingTop: "15px",
            maxWidth: 250,
          }}
          rules={{
            pattern: {
              value:
                "^(0?[1-9]|[12][0-9]|3[01])[\\/\\-](0?[1-9]|1[012])[\\/\\-](2\\d{3})$",
              message: "Veuillez entrer une date valide",
            },
          }}
        >
          {(props: any) => (
            <BataillogDatePicker
              selectedDate={props.value ? new Date(props.value) : undefined}
              onDateChange={(d) =>
                props.onChange(d instanceof Date ? toLocalDateString(d) : null)
              }
              label={props.label}
              error={props.error}
              variant={props.variant}
              displayCalendarIcon
              style={{
                ...props.style,
                justifyContent: "center",
                maxWidth: 240,
                paddingRight: 20,
                width: "100%",
              }}
            />
          )}
        </CField>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            marginLeft: "20px",
          }}
        >
          <RadioGroup
            name="dateType"
            value={String(dispositionDateIsExact)}
            onChange={handleDateTypeChange}
            defaultValue="false"
          >
            <FormControlLabel
              value="true"
              control={<Radio color="primary" />}
              label="Date exacte"
            />
            <FormControlLabel
              value="false"
              control={<Radio color="primary" />}
              label="Au plus tard le"
            />
          </RadioGroup>
        </div>
      </div>
      <Divider className={classes.divider} />
    </div>
  );
}
